import type { StackedPackagePeriod } from "@/modules/packages/domain/lib/stacked-package-periods";
import { formatDate } from "@/shared/lib/date-time";

type SellPackageStackedPeriodPreviewProps = {
  periods: StackedPackagePeriod[];
  sessionsPerPeriod: number;
  pricePerPeriod: number;
  totalSessions: number;
  totalPrice: number;
};

export function SellPackageStackedPeriodPreview({
  periods,
  sessionsPerPeriod,
  pricePerPeriod,
  totalSessions,
  totalPrice,
}: SellPackageStackedPeriodPreviewProps) {
  if (periods.length <= 1) return null;

  const totalDays = periods.reduce((sum, p) => {
    const start = new Date(`${p.startDate}T00:00:00`);
    const end = new Date(`${p.expireDate}T00:00:00`);
    const days = Math.round((end.getTime() - start.getTime()) / 86400000);
    return sum + (Number.isFinite(days) && days >= 0 ? days : 0);
  }, 0);

  return (
    <div className="space-y-3 rounded-lg border bg-muted/30 p-4">
      <div>
        <p className="font-medium text-sm">ຕາຕະລາງຮອບຕໍ່ເນື່ອ</p>
        <p className="text-muted-foreground text-xs">
          ລວມ {periods.length} ຮອບ · {totalSessions} ຄັ້ງ · ~{totalDays} ວັນ ·{" "}
          {totalPrice.toLocaleString("lo-LA")} ກີບ
        </p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[480px] text-sm">
          <thead>
            <tr className="border-b text-left text-muted-foreground text-xs">
              <th className="pb-2 pr-3 font-medium">ຮອບ</th>
              <th className="pb-2 pr-3 font-medium">ເລີ່ມ</th>
              <th className="pb-2 pr-3 font-medium">ສິ້ນສຸດ</th>
              <th className="pb-2 pr-3 font-medium">ຄັ້ງ</th>
              <th className="pb-2 font-medium text-right">ລາຄາ/ຮອບ</th>
            </tr>
          </thead>
          <tbody>
            {periods.map((period) => (
              <tr key={period.periodIndex} className="border-b last:border-0">
                <td className="py-2 pr-3 tabular-nums">{period.periodIndex}</td>
                <td className="py-2 pr-3">{formatDate(period.startDate)}</td>
                <td className="py-2 pr-3">{formatDate(period.expireDate)}</td>
                <td className="py-2 pr-3 tabular-nums">{sessionsPerPeriod}</td>
                <td className="py-2 text-right tabular-nums">
                  {pricePerPeriod.toLocaleString("lo-LA")} ກີບ
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
